<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <thead
        data-slot="table-header"
        :class="cn('[&_th]:inset-shadow-[0_-1px_0_0_var(--table-border)]', props.class)"
    >
        <slot />
    </thead>
</template>
